module.exports = __webpack_public_path__ + "img/activity_other5.8862253d.jpg";